/* eslint-disable no-shadow */
/* eslint-disable func-names */
/* eslint-disable max-len */
/* eslint-disable no-return-assign */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Field, reduxForm } from 'redux-form';
import {
  Card, CardBody, Col, ButtonToolbar, Button, Progress, Modal, ModalHeader, ModalBody, ModalFooter,
} from 'reactstrap';
import axios from 'axios';
import { useHistory, useParams } from 'react-router-dom';
import { message } from 'antd';
import {
  LOCALSTORAGE_TOKEN,
} from '../../../../../utils/Types';
import renderFileInputField from '../../../../../shared/components/form/FileInput';
import {
  URL_CATEGORYCOURSE,
} from '../../../../../utils/EndPoints';

const EditCategoryForm = (stateOri) => {
  const history = useHistory();
  const params = useParams();
  const [progress, setProgress] = useState(null);
  const [isEditable, setEditable] = useState(false);
  const [thumbnail, setThumbnail] = useState(null);
  const [messageApi, contextHolder] = message.useMessage();
  const { location } = history;
  const { state } = location;
  const { initialize } = stateOri;
  const { data } = state;
  const [modal, setModal] = useState(false);
  const toggle = () => {
    setModal(!modal);
  };

  useEffect(() => {
    initialize(data);
  }, []);

  const onSubmit = (e) => {
    e.preventDefault();
    const data = new FormData();
    if (e.target.thumbnail.files[0]) {
      data.append('thumbnail', e.target.thumbnail.files[0]);
    }
    data.append('order_display', e.target.order_display.value);
    data.append('name', e.target.name.value);
    const token = localStorage.getItem(LOCALSTORAGE_TOKEN);
    const options = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Token ${token}`,
      },
      onUploadProgress: (data) => {
        setProgress(Math.round((100 * data.loaded) / data.total));
      },
    };
    axios
      .patch(`${URL_CATEGORYCOURSE + params.id}/`, data, options)
      .then(() => {
        messageApi.success('Topic Successfully Updated');
        history.push('/admin/topic');
      })
      .catch(() => {
        messageApi.error('Topic Failed Updated');
      });
  };

  const imageHandler = () => {
    if (thumbnail) {
      return thumbnail;
    } if (data.thumbnail) {
      return data.thumbnail;
    }
    return '/img/no_image.png';
  };

  const inputImageHandler = (e) => {
    setThumbnail(URL.createObjectURL(e.file));
    const conditions = ['image/png', 'image/jpg', 'image/jpeg'];

    if (!conditions.some((el) => e.file.type.includes(el))) {
      messageApi.open({
        type: 'error',
        content: 'Only image file types allowed',
      });
    }
  };

  return (
    <Col md={12} lg={12}>
      {contextHolder}
      <ButtonToolbar className="form__button-toolbar">
        <Button size="sm" color="danger" onClick={history.goBack}>
          Back
        </Button>
      </ButtonToolbar>
      <Card className="card--not-full-height">
        <CardBody className="dashboard__booking-card">
          <div className="card__title">
            <h5 className="bold-text">Detail Topic</h5>
          </div>
          <form className="form" onSubmit={onSubmit}>
            <img src={imageHandler()} alt="" className="testimonial-image" />
            <span className="form__form-group-label">Thumbnail</span>
            <div className="form__form-group">
              <div className="form__form-group-field mb-0-label">
                <Field
                  name="thumbnail"
                  component={renderFileInputField}
                  required
                  onChange={(e) => { inputImageHandler(e); }}
                />
              </div>
            </div>
            <span className="form__form-group-label">Topic Order
            </span>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <Field
                  name="order_display"
                  disabled={!isEditable}
                  component="input"
                  type="number"
                  required
                />
              </div>
            </div>
            <span className="form__form-group-label">Name</span>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <Field
                  name="name"
                  component="input"
                  type="text"
                  placeholder="Name"
                  required
                  disabled={!isEditable}
                />
              </div>
            </div>

            {progress !== null && (
              <Card>
                <Col md={12} lg={12}>
                  <Progress animated value={progress}>{progress}%</Progress>
                </Col>
              </Card>
            )}

            <ButtonToolbar className="form__button-toolbar">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setEditable(!isEditable)}
                color={isEditable ? 'danger' : 'primary'}
              >
                {' '}
                {!isEditable ? 'Change' : 'Cancel'}
              </button>
              {isEditable && (
                <button
                  type="submit"
                  className="btn btn-primary"
                >
                  {' '}
                  Save
                </button>
              )}
              {isEditable === false && (
                <button
                  type="button"
                  size="sm"
                  onClick={() => toggle()}
                  className="btn btn-danger"
                >
                  Delete
                </button>
              )}
              <Modal
                toggle={toggle}
                isOpen={modal}
                backdrop={false}
              >
                <ModalHeader toggle={toggle}>
                  Delete Topic
                </ModalHeader>
                <ModalBody>
                  Are you sure you want to Delete this Topic?
                </ModalBody>
                <ModalFooter>
                  <Button
                    onClick={() => {
                      const token = localStorage.getItem(LOCALSTORAGE_TOKEN);
                      const options = {
                        headers: {
                          'Content-Type':
                            'application/json',
                          Authorization: `Token ${token}`,
                        },
                      };
                      axios
                        .delete(
                          `${URL_CATEGORYCOURSE}${data.id}`,
                          options,
                        )
                        .then(() => {
                          history.push('/admin/topic/');
                        })
                        .catch(() => {
                          message.error('Something went wrong!');
                        });
                    }}
                  >
                    Delete
                  </Button>
                </ModalFooter>
              </Modal>
            </ButtonToolbar>
          </form>
        </CardBody>
      </Card>
    </Col>
  );
};

export default reduxForm({
  form: 'EditELibrary_form', // a unique identifier for this form
})(EditCategoryForm);
